import React from "react";

import clipboardCopy from "clipboard-copy";

export function capitalizeText(text) {
  if (text) {
    return text
      .replace(/[_-]/g, " ")
      .split(" ")
      .map((segment) => {
        return (
          segment.charAt(0).toUpperCase() + segment.substr(1).toLowerCase()
        );
      })
      .join(" ");
  }
  return text;
}

export function copyText(text, callback) {
  return clipboardCopy(text).then(callback).catch(callback);
}

export function multilineText(text, pattern = /\r?\n/) {
  if (text) {
    return (
      <React.Fragment>
        {text.split(pattern).map((value, key) => (
          <span key={key}>
            {!!key && <br />}
            {value}
          </span>
        ))}
      </React.Fragment>
    );
  }
  return text;
}

export function pluralizeText(text, count) {
  if (text) {
    if (count && Array.isArray(count)) {
      count = count.length;
    }
    return `${text}${count && count === 1 ? "" : "s"}`;
  }
  return text;
}
